<template>
  <div class="manage-tea">
    <h3>员工管理</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-input
          v-model="form2Query.keyUsername"
          placeholder="搜索工号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form2Query.keyName"
          placeholder="搜索姓名"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="onQuery">筛选</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="openAddUserDialog">新增员工</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="info" @click="openDepartmentDialog">部门管理</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="handleResetPass">重置密码</el-button>
      </el-form-item>
      <el-form-item>
        <el-popconfirm
          confirm-button-text="确认删除"
          cancel-button-text="不用了"
          confirm-button-type="danger"
          cancel-button-type=""
          icon="el-icon-info"
          icon-color="red"
          title="确认删除该员工？删除后员工将无法登录系统，但所有业务数据（合同记录、申请记录等）会完整保留。如需恢复，可使用相同账号重新添加。"
          @confirm="handleDel"
        >
          <el-button type="danger" slot="reference">删除员工</el-button>
        </el-popconfirm>
      </el-form-item>
    </el-form>
    <div class="check-group">
      <span>显示列：</span>
      <el-checkbox
        v-for="col in Columns"
        v-model="col.ifShow"
        :key="col.value"
        size="small"
        style="margin-right:10px"
        >{{ col.name }}</el-checkbox
      >
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @sort-change="onSortChange"
      @selection-change="handleSelectionChange"
    >
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <template v-for="col in Columns">
        <el-table-column
          align="center"
          v-if="col.ifShow"
          :prop="col.value"
          :width="col.width"
          :label="col.name"
          sortable
          :key="col.value"
        >
        </el-table-column>
      </template>
      <el-table-column label="操作" width="80" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="select2Change(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageSize"
      :layout="paginationLayout"
      :small="ifSmall"
      :total="dataCount"
    >
    </el-pagination>
    <el-dialog title="修改员工信息" :visible.sync="ifShowUpdateDialog" width="480px">
      <el-form label-position="left" label-width="90px" @submit.native.prevent>
        <el-form-item label="姓名">
          <el-input
            v-model="selectTea.name"
            @change="handleChange"
            name="name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="设置权限">
          <div style="display:flex;flex-wrap:wrap;align-items:center;gap:8px;">
            <template v-if="selectTea.roleId === 1">
              <span class="role-readonly">角色：系统管理员</span>
              <el-select
                v-model="newDepartmentId"
                placeholder="部门"
                clearable
                size="small"
                style="width:160px"
              >
                <el-option v-for="d in departmentList" :key="d.id" :label="d.name" :value="d.id" />
              </el-select>
            </template>
            <template v-else>
              <el-select v-model="newRoleId" placeholder="角色" size="small" style="width:140px">
                <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id" />
              </el-select>
              <el-select
                v-if="newRoleId === 2 || newRoleId === 4"
                v-model="newDepartmentId"
                placeholder="部门"
                clearable
                size="small"
                style="width:160px"
              >
                <el-option v-for="d in departmentList" :key="d.id" :label="d.name" :value="d.id" />
              </el-select>
            </template>
            <el-button type="primary" size="small" @click="saveRoleAndDepartment">保存</el-button>
          </div>
          <div class="tip-text">员工/部门经理可设角色与部门；管理员仅可设所属部门（设后该部门经理能在合同管理中看到其上传的合同）。</div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="部门管理" :visible.sync="ifShowDepartmentDialog" width="520px">
      <div class="department-add">
        <el-input v-model="newDepartmentName" placeholder="输入新部门名称，如：项目部、技术部" size="small" style="width:260px;margin-right:8px" />
        <el-button type="primary" size="small" @click="submitAddDepartment">添加部门</el-button>
      </div>
      <el-table :data="departmentList" border size="small" style="margin-top:12px">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="部门名称">
          <template slot-scope="scope">
            <span v-if="scope.row.id !== editingDepartmentId">{{ scope.row.name }}</span>
            <el-input
              v-else
              v-model="editingDepartmentName"
              size="mini"
              style="width:180px"
              @blur="submitUpdateDepartment(scope.row)"
              @keyup.enter.native="submitUpdateDepartment(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button v-if="scope.row.id !== editingDepartmentId" type="text" size="small" @click="startEditDepartment(scope.row)">编辑</el-button>
            <el-button v-else type="text" size="small" @click="cancelEditDepartment">取消</el-button>
            <el-popconfirm
              v-if="scope.row.id !== editingDepartmentId"
              title="确定删除该部门？删除后原属该部门的员工将变为未分配部门。"
              confirm-button-text="确定"
              cancel-button-text="取消"
              @confirm="submitDeleteDepartment(scope.row)"
            >
              <el-button slot="reference" type="text" size="small" style="color:#f56c6c">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="新增员工" :visible.sync="ifShowAddUserDialog" width="420px" @close="resetAddUserForm">
      <p class="add-user-tip">密码默认为账号，后续自行修改。</p>
      <el-form ref="addUserFormRef" :model="addUserForm" :rules="addUserRules" label-width="80px" size="small">
        <el-form-item label="账号" prop="username">
          <el-input v-model="addUserForm.username" placeholder="11位数字" maxlength="11" show-word-limit />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addUserForm.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="性别" prop="genderId">
          <el-select v-model="addUserForm.genderId" placeholder="请选择性别" style="width:100%">
            <el-option v-for="g in genderOptions" :key="g.id" :label="g.name" :value="g.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="addUserForm.roleId" placeholder="请选择角色" style="width:100%">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="departmentId" v-if="needDepartment">
          <el-select v-model="addUserForm.departmentId" placeholder="请选择部门" clearable style="width:100%">
            <el-option
              v-for="d in departmentList"
              :key="d.id"
              :label="d.name"
              :value="d.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <span class="dialog-footer">
          <el-button @click="ifShowAddUserDialog = false">取 消</el-button>
          <el-button type="primary" :loading="addUserSubmitting" @click="submitAddUser">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTeaList,
  initManageTea,
  getDepartmentList,
  getClassList,
  delTea,
  resetTeaPass,
  updateTea,
  setRole,
  addTeacher,
  updateRoleAndDepartment,
  updateUserDepartment,
  addDepartment,
  updateDepartment,
  deleteDepartment,
} from "../api";
export default {
  name: "ManageTea",
  components: {},
  computed: {},
  data() {
    return {
      ifSmall:false,
      paginationLayout: "prev, pager,next, jumper, ->, total, sizes",
      ifShowUpdateDialog: false, //修改弹窗
      selectTea: {}, //选中的教师
      oldRoleId: "",
      newRoleId: "",
      newDepartmentId: null, // 编辑时的部门
      ifShowDepartmentDialog: false,
      newDepartmentName: "",
      editingDepartmentId: null,
      editingDepartmentName: "",
      // 数据列
      Columns: [
        { name: "ID", value: "userId", width: "100", ifShow: true },
        { name: "工号", value: "username", width: "150", ifShow: true },
        { name: "姓名", value: "name", width: "120", ifShow: true },
        { name: "性别", value: "genderName", width: "80", ifShow: false },
        { name: "角色", value: "roleName", width: "auto", ifShow: true },
        { name: "部门", value: "departmentName", width: "120", ifShow: true },
      ],
      currentPage: 1,
      pageSize: 10,
      tableData: [{}], //展示的数据
      dataCount: 0, //总数据条数
      orderMode: "", //排序方式
      orderField: "", //排序字段
      //用于筛选的表单
      form2Query: {
        keyUsername: "", //教职工
        keyName: "", //姓名
      },
      //用于筛选的表单
      form2Search: {
        gradeId: "", 
        majorId: "", 
        classId: "",
      },
      //下拉栏内容列表
      gradeList: [],
      majorList: [],
      classList: [],
      roleList: [],
      departmentList: [],
      //选中的数据
      multipleSelection: [],
      // 新增用户
      ifShowAddUserDialog: false,
      addUserSubmitting: false,
      genderOptions: [
        { id: 1, name: "男" },
        { id: 2, name: "女" },
      ],
      addUserForm: {
        username: "",
        name: "",
        genderId: 1,
        roleId: null,
        departmentId: null,
      },
      addUserRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { pattern: /^[0-9]{11}$/, message: "账号必须为11位数字", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        genderId: [{ required: true, message: "请选择性别", trigger: "change" }],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
    };
  },
  computed: {
    needDepartment() {
      return this.addUserForm.roleId === 2 || this.addUserForm.roleId === 4;
    },
  },
  mounted() {
    this.initQueryList();
    this.onQuery();
    if (document.documentElement.clientWidth < 720) {
      //closeDebug console.log("触发移动端布局");
      this.ifSmall = true
      this.paginationLayout = "prev, pager,next, ->, total";
      this.Columns=[
        { name: "ID", value: "userId", width: "100", ifShow: false },
        { name: "工号", value: "username", width: "150", ifShow: false },
        { name: "姓名", value: "name", width: "80", ifShow: true },
        { name: "性别", value: "genderName", width: "80", ifShow: false },
        { name: "角色", value: "roleName", width: "auto", ifShow: true },
        { name: "部门", value: "departmentName", width: "120", ifShow: true },
      ]
    }
  },
  methods: {
    //初始化查询参数（年级、专业、角色来自 index，部门单独接口拉取）
    initQueryList() {
      initManageTea()
        .then((res) => {
          let obj = typeof res.msg === "string" ? JSON.parse(res.msg) : res.msg || res;
          if (obj) {
            this.gradeList = obj.grade || [];
            this.majorList = obj.major || [];
            this.roleList = obj.role || [];
          }
        })
        .catch(() => {});
      getDepartmentList()
        .then((res) => {
          this.departmentList = Array.isArray(res) ? res : (res && res.data) ? res.data : [];
        })
        .catch(() => {
          this.departmentList = [];
        });
    },
    //更新可供筛选的班级列表
    QueryClass() {
      let _this = this;
      _this.form2Query.classId = "";
      //closeDebug console.log("选中的筛选值","年级：",this.form2Search.gradeId,"专业",this.form2Search.majorId);
      let params = new URLSearchParams();
      params.append("gradeId", this.form2Search.gradeId);
      params.append("majorId", this.form2Search.majorId);
      getClassList(params)
        .then((res) => {
          //closeDebug console.log("-----------获取班级列表---------------");
          //closeDebug console.log(res);
          _this.classList = res;
        })
        .catch((failResponse) => {});
    },

    //处理多选框变化
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //closeDebug console.log("多选框：", val);
    },
    openAddUserDialog() {
      this.ifShowAddUserDialog = true;
      this.$nextTick(() => {
        this.$refs.addUserFormRef && this.$refs.addUserFormRef.clearValidate();
      });
    },
    resetAddUserForm() {
      this.addUserForm = { username: "", name: "", genderId: 1, roleId: null, departmentId: null };
      this.$refs.addUserFormRef && this.$refs.addUserFormRef.resetFields();
    },
    submitAddUser() {
      this.$refs.addUserFormRef.validate((valid) => {
        if (!valid) return;
        this.addUserSubmitting = true;
        const params = new URLSearchParams();
        params.append("username", this.addUserForm.username);
        params.append("name", this.addUserForm.name);
        params.append("genderId", this.addUserForm.genderId);
        params.append("roleId", this.addUserForm.roleId);
        if (this.addUserForm.departmentId != null && this.addUserForm.departmentId !== "") {
          params.append("departmentId", this.addUserForm.departmentId);
        }
        addTeacher(params)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg || "新增员工成功");
              this.ifShowAddUserDialog = false;
              this.onQuery();
            } else {
              this.$message.error(res.msg || "新增员工失败");
            }
          })
          .catch(() => {})
          .finally(() => {
            this.addUserSubmitting = false;
          });
      });
    },
    //处理重置用户密码
    handleResetPass() {
      let params = new URLSearchParams();
      for (let tea in this.multipleSelection) {
        params.append("ids[]", this.multipleSelection[tea].userId);
      }
      let _this = this;
      resetTeaPass(params)
        .then((res) => {
          //closeDebug console.log("-----------重置用户密码---------------");
          if (res.code === 0) {
            _this.$message({
              message: res.msg,
              type: "success",
            });
            this.$refs.multipleTable.clearSelection();
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((failResponse) => {});
    },
    //处理删除教师
    handleDel() {
      let params = new URLSearchParams();
      for (let tea in this.multipleSelection) {
        params.append("teacherNos[]", this.multipleSelection[tea].teaNo);
      }
      let _this = this;
      delTea(params)
        .then((res) => {
          //closeDebug console.log("-----------删除用户---------------");
          if (res.code === 0) {
            _this.$message({
              message: res.msg,
              type: "success",
            });
            _this.onQuery();
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((failResponse) => {});
    },
    //数据格式化(还没用到)
    formatter(row, column) {
      return row.address;
    },
    //处理每页显示数据量变化
    handleSizeChange(val) {
      this.pageSize = val;
      //closeDebug console.log(`每页 ${val} 条`);
      this.onQuery();
    },
    //处理跳页
    handleCurrentChange(val) {
      this.currentPage = val;
      //closeDebug console.log(`当前页: ${val}`);
      this.onQuery();
    },
    //处理修改信息（打开编辑弹窗时刷新部门列表，保证部门下拉有数据）
    select2Change(index, row) {
      this.selectTea = row;
      this.oldRoleId = row.roleId;
      this.newRoleId = row.roleId;
      this.newDepartmentId = row.departmentId != null ? row.departmentId : null;
      this.ifShowUpdateDialog = true;
      getDepartmentList()
        .then((res) => {
          this.departmentList = Array.isArray(res) ? res : (res && res.data) ? res.data : [];
        })
        .catch(() => {});
    },
    handleChange(val) {
      //closeDebug console.log("onchange:", val);
      let params = new URLSearchParams();
      params.append("username", this.selectTea.username);
      params.append("newName", this.selectTea.name);
      let _this = this;
      updateTea(params)
        .then((res) => {
          //closeDebug console.log("-----------更新教师信息---------------");
          if (res.code === 0) {
            _this.$message({
              message: res.msg,
              type: "success",
            });
            _this.onQuery();
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((failResponse) => {});
    },
    saveRoleAndDepartment() {
      const userId = this.selectTea.userId;
      const departmentId = this.newDepartmentId != null && this.newDepartmentId !== "" ? this.newDepartmentId : null;
      // 管理员(roleId=1)只更新部门
      if (this.newRoleId === 1) {
        updateUserDepartment({ userId, departmentId })
          .then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg || "部门已更新");
              this.ifShowUpdateDialog = false;
              this.onQuery();
            } else {
              this.$message.error(res.msg || "更新失败");
            }
          })
          .catch(() => {});
        return;
      }
      if (this.newRoleId !== 2 && this.newRoleId !== 4) {
        this.$message.warning("请选择「员工」或「部门经理」");
        return;
      }
      const params = { userId, roleId: this.newRoleId };
      if (departmentId != null) params.departmentId = departmentId;
      const _this = this;
      updateRoleAndDepartment(params)
        .then((res) => {
          if (res.code === 0) {
            _this.$message.success(res.msg || "角色与部门已更新");
            _this.ifShowUpdateDialog = false;
            _this.onQuery();
          } else {
            _this.$message.error(res.msg || "更新失败");
          }
        })
        .catch(() => {});
    },
    openDepartmentDialog() {
      this.newDepartmentName = "";
      this.editingDepartmentId = null;
      this.ifShowDepartmentDialog = true;
      getDepartmentList()
        .then((res) => {
          this.departmentList = Array.isArray(res) ? res : (res && res.data) ? res.data : [];
        })
        .catch(() => {});
    },
    submitAddDepartment() {
      const name = (this.newDepartmentName || "").trim();
      if (!name) {
        this.$message.warning("请输入部门名称");
        return;
      }
      const _this = this;
      addDepartment({ name })
        .then((res) => {
          if (res.code === 0) {
            _this.$message.success(res.msg || "部门已添加");
            _this.newDepartmentName = "";
            _this.initQueryList();
          } else {
            _this.$message.error(res.msg || "添加失败");
          }
        })
        .catch(() => {});
    },
    startEditDepartment(row) {
      this.editingDepartmentId = row.id;
      this.editingDepartmentName = row.name;
    },
    cancelEditDepartment() {
      this.editingDepartmentId = null;
      this.editingDepartmentName = "";
    },
    submitUpdateDepartment(row) {
      const name = (this.editingDepartmentName || "").trim();
      if (!name) {
        this.cancelEditDepartment();
        return;
      }
      const _this = this;
      updateDepartment({ id: row.id, name })
        .then((res) => {
          if (res.code === 0) {
            _this.$message.success(res.msg || "部门已更新");
            _this.editingDepartmentId = null;
            _this.editingDepartmentName = "";
            _this.refreshDepartmentList();
          } else {
            _this.$message.error(res.msg || "更新失败");
          }
        })
        .catch(() => {});
    },
    refreshDepartmentList() {
      getDepartmentList()
        .then((res) => {
          this.departmentList = Array.isArray(res) ? res : (res && res.data) ? res.data : [];
        })
        .catch(() => {});
    },
    submitDeleteDepartment(row) {
      const _this = this;
      deleteDepartment({ id: row.id })
        .then((res) => {
          if (res.code === 0) {
            _this.$message.success(res.msg || "部门已删除");
            _this.refreshDepartmentList();
          } else {
            _this.$message.error(res.msg || "删除失败");
          }
        })
        .catch(() => {});
    },
    onSetRole() {
      let params = new URLSearchParams();
      params.append("ids[]", this.selectTea.userId);
      params.append("usernames[]", this.selectTea.username);
      params.append("roleId", this.newRoleId);
      params.append("oldroleIds[]", this.oldRoleId);
      if (this.newRoleId === 2) {
        for (let item in this.form2Search.classId) {
          params.append("classIds[]", this.form2Search.classId[item]);
        }
      }
      let _this = this;
      setRole(params)
        .then((res) => {
          if (res.code === 0) {
            _this.$message({
              message: res.msg,
              type: "success",
            });
            _this.onQuery();
            _this.form2Search.gradeId="";
            _this.form2Search.majorId="";
            _this.form2Search.classId="";
            _this.ifShowUpdateDialog=false;
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((failResponse) => {});
    },
    //处理数据筛选
    onQuery() {
      //closeDebug console.log("submit:", this.form2Query);
      //参数绑定「分页大小、页码以及筛选参数」
      let params = new URLSearchParams();
      params.append("limit", this.pageSize);
      params.append("page", this.currentPage);
      params.append("keyUsername", this.form2Query.keyUsername); //用户id
      params.append("keyName", this.form2Query.keyName); //姓名
      params.append("order", this.orderMode); //排序方式
      params.append("field", this.orderField); //排序字段
      getTeaList(params)
        .then((res) => {
          //closeDebug console.log("-----------获取筛选后的表格数据---------------");
          //closeDebug console.log(res.data);
          this.tableData = res.data;
          this.dataCount = res.count;
        })
        .catch((failResponse) => {});
    },
    //处理排序后重新获取数据
    onSortChange(res) {
      //closeDebug console.log("触发排序:", res);
      if (res.order) {
        this.orderMode = res.order === "descending" ? "desc" : "asc";
        this.orderField = res.prop;
      } else {
        this.orderMode = "";
        this.orderField = "";
      }
      //closeDebug console.log(this.orderMode, this.orderField);
      this.onQuery();
    },
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
}
.check-group {
  margin-bottom: 10px;
}
.check-group > span {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}
.tip-text {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
  line-height: 1.4;
}
.role-readonly {
  font-size: 12px;
  color: #606266;
  margin-right: 4px;
}
.department-add {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
